import { render, staticRenderFns } from "./createEditMerchant.vue?vue&type=template&id=afb7dbae&scoped=true&"
import script from "./createEditMerchant.vue?vue&type=script&lang=js&"
export * from "./createEditMerchant.vue?vue&type=script&lang=js&"
import style0 from "./createEditMerchant.vue?vue&type=style&index=0&id=afb7dbae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb7dbae",
  null
  
)

export default component.exports